import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

export interface IMaintenanceWindow {
    local: string;
    utc: string;
}

export default function getMaintenanceWindows(): IMaintenanceWindow[] {
    const instanceRegion = window.location.origin;

    const timeObject: Record<string, number> = {};

    switch (true) {
        case !!instanceRegion.match(/\.ap\./):
            timeObject['9am'] = 23;
            timeObject['3pm'] = 5;
            timeObject['11pm'] = 13;
            break;
        case !!instanceRegion.match(/\.eu\./):
            timeObject['9am'] = 8;
            timeObject['3pm'] = 14;
            timeObject['11pm'] = 22;
            break;
        default:
            timeObject['9am'] = 14;
            timeObject['3pm'] = 20;
            timeObject['11pm'] = 4;
    }

    const time9AM = dayjs.utc().hour(timeObject['9am']).startOf('hour');
    const time3PM = dayjs.utc().hour(timeObject['3pm']).startOf('hour');
    const time11PM = dayjs.utc().hour(timeObject['11pm']).startOf('hour');

    return [
        {
            local: `${dayjs(time9AM).local().format('h:mma')} - ${dayjs(time9AM).local().add(2, 'h').format('h:mma')}`,
            utc: `${time9AM.format('h:mma')} - ${dayjs(time9AM).add(2, 'h').format('h:mma')}`
        },
        {
            local: `${dayjs(time3PM).local().format('h:mma')} - ${dayjs(time3PM).local().add(2, 'h').format('h:mma')}`,
            utc: `${time3PM.format('h:mma')} - ${dayjs(time3PM).add(2, 'h').format('h:mma')}`
        },
        {
            local: `${dayjs(time11PM).local().format('h:mma')} - ${dayjs(time11PM).local().add(2, 'h').format('h:mma')}`,
            utc: `${time11PM.format('h:mma')} - ${dayjs(time11PM).add(2, 'h').format('h:mma')}`
        }
    ];
}
